import { render, staticRenderFns } from "./inventory-def-name.vue?vue&type=template&id=d24132ae&scoped=true&"
import script from "./inventory-def-name.vue?vue&type=script&lang=js&"
export * from "./inventory-def-name.vue?vue&type=script&lang=js&"
import style0 from "./inventory-def-name.vue?vue&type=style&index=0&id=d24132ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24132ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VIcon,VMenu})
